import type { ValueOf } from '#layers/base/types/utils';

export const LineWrappingMode = {
	Toggle: 'toggle',
	On: 'on',
	Off: 'off',
} as const;

export type LineWrappingMode = ValueOf<typeof LineWrappingMode>;
